import Vue from "vue";
import http from "../utils/http";

export default {
  verificarLicenca() {
    const config = {
      method: "get",
      url: `/api/status/`
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(e => {
          if (e.response.status == 404) {
            Vue.notify({
              group: "geral",
              type: "error",
              title: "Ops!",
              text: e.response.data
            });
          } else {
            Vue.notify({
              group: "geral",
              type: "error",
              title: "Ops!",
              text:
                "Não foi possível conectar ao servidor para verificar a licença! Verifique a Url de Serviço e a Chave de Acesso."
            });
          }
          reject(e);
        });
    });
  },
  uploadLicenca(arquivo) {
    let formData = new FormData();
    formData.append("arquivo", arquivo);
    const config = {
      method: "post",
      url: `/api/licenca/upload`,
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data: formData
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          Vue.notify({
            group: "geral",
            type: "success",
            title: "Sucesso!",
            text: "Licença atualizada!"
          });
          resolve(resp.data);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao enviar licença."
          });
          reject(e);
        });
    });
  },
  dispositivos() {
    const config = {
      method: "get",
      url: `/api/dispositivo/`
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao carregar os dispositivos."
          });
          reject(e);
        });
    });
  },
  salvarDispositivo(data) {
    let config = {};
    if (data.id) {
      config = {
        method: "put",
        url: `/api/dispositivo/${data.id}`,
        data
      };
    } else {
      config = {
        method: "post",
        url: "/api/dispositivo/",
        data
      };
    }
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          Vue.notify({
            group: "geral",
            type: "success",
            title: "Registro Salvo!",
            text: "O dispositivo foi salvo com sucesso."
          });
          resolve(resp);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao salvar dispositivo."
          });
          reject(e);
        });
    });
  },
  removerDispositivo(dispositivoId) {
    const config = {
      method: "delete",
      url: `/api/dispositivo/${dispositivoId}`
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          Vue.notify({
            group: "geral",
            type: "success",
            title: "Registro removido!",
            text: "O dispositivo foi removido com sucesso."
          });
          resolve(resp.data);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao deletar o dispositivo."
          });
          reject(e);
        });
    });
  },
  echoDispositivo(dispositivoId) {
    const config = {
      method: "get",
      url: `/api/dispositivo/echo/${dispositivoId}`
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          if (resp.status === 400) {
            Vue.notify({
              group: "geral",
              type: "error",
              title: "Falha!",
              text: "Não foi possivel realizar o echo no dispositivo."
            });
          } else {
            Vue.notify({
              group: "geral",
              type: "success",
              title: "Echo realizado!",
              text: "O echo com o dispositivo foi relizado com sucesso."
            });
          }
          resolve(resp.data);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao realizar o echo."
          });
          reject(e);
        });
    });
  },
  armazenamentos() {
    const config = {
      method: "get",
      url: `/api/armazenamento/`
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text:
              "Ocorreu um erro ao carregar os armazenamentos. Verifique a Url de Serviço e a Chave de Acesso."
          });
          reject(e);
        });
    });
  },
  salvarArmazenamento(data) {
    let config = {};
    if (data.id) {
      config = {
        method: "put",
        url: `/api/armazenamento/${data.id}`,
        data: { dirBase: data.dirBase }
      };
    } else {
      config = {
        method: "post",
        url: `/api/armazenamento/`,
        data: { dirBase: data.dirBase }
      };
    }
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          Vue.notify({
            group: "geral",
            type: "success",
            title: "Registro Salvo!",
            text: "O armazenamento foi salvo com sucesso."
          });
          resolve(resp);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao salvar armazenamento."
          });
          reject(e);
        });
    });
  },
  ativarArmazenamento(data) {
    const config = {
      method: "post",
      url: `/api/armazenamento/${data.id}/ativar`,
      data: { armazenamento: data }
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao ativar o armazenamento."
          });
          reject(e);
        });
    });
  }
};
